export const baseUrl = "https://subinvotrack.com/axcel-painting";
//export const baseUrl = "http://192.168.4.12:8080/axcel-painting";
//export const baseUrl = "http://34.238.14.72:8080";
//export const  baseUrl = "http://localhost:8080/axcel-painting"